import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { Globe } from "lucide-react-native";

import { themes } from "@/Components/Styling/themeConfigs";

function AuthHeader(): React.JSX.Element {
  const currentTheme = themes.morning;

  return (
    <View style={styles.centerContent}>
      <Text style={[styles.title, { color: currentTheme.text }]}>
        Kai Social
      </Text>
      <View style={styles.taglineContainer}>
        <Globe color={currentTheme.text} size={20} />
        <Text style={[styles.tagline, { color: currentTheme.text }]}>
          Explore, Connect, and Impress.
        </Text>
      </View>
      <Text style={[styles.subtext, { color: currentTheme.subtext }]}>
        Be among the first to join our community
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  centerContent: {
    flex: 1,
    alignItems: "center",
  },
  title: {
    fontSize: 48,
    fontWeight: "bold",
    marginBottom: 8,
  },
  taglineContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  tagline: {
    fontSize: 24,
    fontWeight: "600",
    marginLeft: 8,
  },
  subtext: {
    fontSize: 16,
    marginTop: 8,
  },
});

export default AuthHeader;
